<template>
    <span class="projectContent">
        <h1 class="projectTitle">
            Bee Careful
        </h1>
        <h2 class="projectSubTitle">
           Course Work of BVW Created in Just One Week
        </h2>
        <h4>
            Team Members:
        </h4>
        <p>
            Regina Xia (Artist + Producer), Alex Zhu (Artist), Aaron Min (Programmer), <u>Bonny Wang</u> (Programmer), Daaa Zhao (Tech Designer)
        </p>
        <h4>
            Description:
        </h4>
        <p>
            Three players act as bees, utilizing eye trackers to assail the beekeeper, while one player assumes the role of a beekeeper, using a controller to capture bees.
            
        </p>
        <h4>
            Technologies Used:
        </h4>
        <p>
            Eye Tracker, Keyboard, Mouse | 4 Players (1 vs 3)
            <br>
            <br>
            Google Firebase realtime database for multiplayer experience
        </p>
        <h4>
            Game Screenshots:
        </h4>
        <img width="80%" src="ImgOriginal/BeeCareful_Start.png">
        <img width="80%" src="ImgOriginal/BeeCareful_Screen.png">
        <h4>
            Gameplay video:
        </h4>
        <iframe width="80%" height="315" src="https://www.youtube.com/embed/fIo74ZM1lMg?si=uJm6EIqY6-t2ePmp" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        
    </span>
  
</template>

<script>
export default {
    name:"BeeCareful"

}
</script>

<style>

</style>